import React, { useCallback, useState } from 'react';
import { Box, LeftRow, Row, Subtitle, Tag, Title } from '../styles';
import Modal from '../../modals/modal';
import VercelIntegrationModal from '../../modals/vercelIntegrationModal';
import { setVercelProject } from '../../../services/vercelService';
import { rootStore } from '../../../mobx/rootStore';
import { error } from 'highcharts';
import { observer } from 'mobx-react-lite';
import { VercelProject } from '../../../mobx/interfaces/project';

const VercelSettingCard = () => {
  //State variables
  const [isVercelProjectModelOpen, setIsVercelProjectModelOpen] = useState(false);
  //Mobx store variables
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;

  // function to set repositories
  const handleSelectVercelProject = useCallback(
    async (project: VercelProject) => {
      try {
        const response = await setVercelProject(currentProject?.id, project);
        if (response) {
          currentProject?.setVercelProject(project);
          setIsVercelProjectModelOpen(false);
        }
      } catch (e) {
        console.log('error', error);
      }
    },
    [currentProject]
  );

  // select repo model open
  const openVercelProjectSelector = useCallback(() => {
    setIsVercelProjectModelOpen(true);
  }, []);

  // select repo model close
  const closeVercelProjectSelector = useCallback(() => {
    setIsVercelProjectModelOpen(false);
  }, []);
  return (
    <>
      <Box>
        <Row>
          <LeftRow>
            <Title>Vercel account</Title>
            {/* show project name */}
            <Subtitle>{currentProject?.vercelProject?.name}</Subtitle>
          </LeftRow>

          {/* project is selected */}
          <Tag role='button' onClick={openVercelProjectSelector}>
            Change
          </Tag>
        </Row>
      </Box>
      <Modal open={isVercelProjectModelOpen} onClose={closeVercelProjectSelector} maxWidth={'460px'}>
        <VercelIntegrationModal onClose={closeVercelProjectSelector} handleSelect={handleSelectVercelProject} />
      </Modal>
    </>
  );
};

export default observer(VercelSettingCard);
